import {
  ApiDaysOnHandRequiredRequest,
  ApiDaysOnHandRequiredResponse,
  ApiFrequenciesRequiredResponse,
  HttpUrlParams,
} from 'src/app/core/models';

export const getFrequenciesRequired = (): ApiFrequenciesRequiredResponse[] => [
  {
    cgmSiteChgFreqRequired: true,
    pumpSiteChgFreqRequired: false,
    patientTestFreqRequired: false,
  },
];

export const getDaysOnHandRequired = (
  urlParams: HttpUrlParams | undefined,
  body: ApiDaysOnHandRequiredRequest
): ApiDaysOnHandRequiredResponse[] => {
  return body.supplies.map((item, i) => ({
    itemId: item.itemId,
    daysOnHandRequired: i % 2 ? true : false,
  }));
};
